import { httpClient } from '@/infra/protocols/http';
import { IMusicUploadDTO } from '@/modules/musics/dto/music-upload.dto';
import { IMusicUpload } from '@/modules/musics/entities/music-upload.entity';
import { MusicUploadMapper } from '@/modules/musics/mappers/music-upload.mapper';

export async function createMusic(
  params: CreateMusicService.Params,
  data: CreateMusicService.Payload,
): Promise<CreateMusicService.Response> {
  const body = {
    nome: data.name,
    descricao: data.description,
    nomeArquivo: data.filename,
  };

  const response = await httpClient.post<IMusicUploadDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/musicas/upload`,
    body,
  );

  return MusicUploadMapper.toPresentation(response);
}

export namespace CreateMusicService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export interface Payload {
    name: string;
    filename: string;
    description: string;
  }

  export type Response = IMusicUpload;
}
